module.exports = __webpack_public_path__ + "static/media/aeronave.9a63e494.glb";